module.exports = __webpack_public_path__ + "img/sms.ecae7af8.png";